export interface HrReportsState {
    selectedItems : Array<UserObject>,
    updating : boolean,
    showHint : boolean,
    reports : ReportsType,
    totalReports : number,
    contextOpen: boolean;
}

export const UPDATE_REPORTS = "UPDATE_REPORTS";
export const UPDATE_PROGRESS = "UPDATE_PROGRESS";
export const TOGGLE_HINT = "TOGGLE_HINT";
export const ADD_REPORT = "ADD_REPORT";
export const POPULATE_REPORTS = "POPULATE_REPORTS";
export const DELETE_REPORT = "DELETE_REPORT";
export const TOGGLE_CONTEXT = "TOGGLE_CONTEXT";

export type ReportTypes = "userlist" | "filters";

export type ReportsType = {
    [key: string] : Array<{
        type : ReportTypes,
        data : FilterObject
    }>
}

interface deleteReport {
    type : typeof DELETE_REPORT,
    payload : string
}

interface populateReports {
    type : typeof POPULATE_REPORTS,
    payload : any
}

interface updateReports {
    type : typeof UPDATE_REPORTS;
    payload : Array<UserObject>
}

interface updateProgress {
    type : typeof UPDATE_PROGRESS;
    payload : boolean
}

interface toggleHint {
    type : typeof TOGGLE_HINT,
    payload : boolean
}

interface toggleContext {
    type: typeof TOGGLE_CONTEXT,
    payload: boolean
}

// interface addReport {
//     type : typeof ADD_REPORT,
//     payload : {
//         rows : Array<UserObject>,
//         name : string,
//     }
// }

interface addReport {
    type : typeof ADD_REPORT,
    payload : {
        type : ReportTypes,
        data : FilterObject,
        name : string
    }
}

export type UserObject = {
    UserId : number,
    UserName : string,
    DisplayName : string,
    ProfitCenter : string,
    SupervisorId : number,
    Supervisor : string,
    ProfitCenterId : number,
    state : string | null,
    EmployeeNumber : string | number,
    LocationCode : string,
    City : string | null,
    Address1 : string | null,
    Address2 : string | null,
    HomePhone : string,
    WorkPhone : string,
    Email : string | null,
    DefaultState : string | null,
    SeniorityDate : string | null,
    RehireDate : string | null,
    HireDate : string | null,
    TerminationDate : string | null,
    Inactive : boolean,
    PreferredName : string | null,
    MiddleName : string | null,
    LastName : string | null,
    FirstName : string | null
}

export type FilterObject = {
    UserId? : Array<string>
    Username?: Array<string>;
    Supervisor?: Array<string>;
    ProfitCenter?: Array<string>;
    HomeDepartment?: Array<string>;
    HomeDepartmentState?: Array<string>;
    ResidenceState?: Array<string>;
    // Need to change value of State Select to return 2 character code
    EmploymentStatus?: Array<string>;
    PayType?: Array<string>;
    Union?: Array<string>;
    // If search history is true
    // fromUtc?: Date | null;
    // toUtc?: Date | null;
}

export type HrReportsTypes = updateReports | updateProgress | toggleHint | addReport | populateReports | deleteReport | toggleContext;